module.exports = __webpack_public_path__ + "img/icon_dongle_active.c1dda0db.svg";